// extracted by mini-css-extract-plugin
export default {"pagefooter":"PageFooter_pagefooter__Fz+Pf","footeritems":"PageFooter_footeritems__XzpRJ"};